import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { Anchor } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { RenderingProps } from 'src/shared/shared.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export type C08LinkListItemProps = RenderingProps<{ Link?: LinkField }>;

export const Default = (props?: C08LinkListItemProps) => {
  const { renderLink } = useConditionalRendering();

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  const link = renderLink(props?.fields?.Link);
  return link && <Anchor>{link}</Anchor>;
};
